class Backend {
    init() {
        this.$container = $("#backend-dashboard");

        if (this.$container.length === 0) {
            return;
        }

        this.initHideProposalButton();
    }

    initHideProposalButton() {
        this.$container.find(".hide-proposal-btn").on("click", event => {
            event.preventDefault();

            let $button = $(event.currentTarget);
            let url = $button.attr("data-hide-url");

            $.get(url, data => {
               if (data.success === true) {
                   $button.closest("tr").fadeOut();

                   let $table = this.$container.find('.proposals-table');
                   if ($table.find("tr").length === 2) {
                       $table.hide();
                       this.$container.find(".no-proposals-hint").show();
                   }
               }
            });

            return false;
        });
    }
}

export default Backend;